export default "__VITE_ASSET__VjIziyza__"